























import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { User } from '@/models/user';
import { namespace } from 'vuex-class';
import { UserRole } from '@/models/user-role';

const userModule = namespace('user');
@Component
export default class EditRoleModal extends Vue {
    @userModule.Getter('user') public currentUser: User;
    @userModule.Getter('userIsSystem') public userIsSystem: (user: User) => boolean;
    @Prop({ required: true, type: Boolean }) public show: boolean;
    @Prop({ required: true }) public user: User;
    public showing: boolean = this.show;
    public selectedRoleId: string | null = null;
    public rolesToGrant: Array<{ id: string, name: string }> = new Array<{ id: string, name: string }>();
    public rolesToRevoke: Array<{ id: string, name: string }> = new Array<{ id: string, name: string }>();

    @Watch('selectedRoleId')
    public onSelectedRoleIdChanged(value: string | null): void {
        // Clean up arrays on every change
        this.rolesToGrant.length = 0;
        this.rolesToRevoke.length = 0;
        // If user has 'User' role and we select 'Admin'
        const adminRole = this.allRoles().find((r) => r.name === 'role:admin') || null;
        const userRole = this.allRoles().find((r) => r.name === 'role:user') || null;
        const userIsAdmin = this.priorityRoleId() === adminRole!.id;
        const userIsUser = this.priorityRoleId() === userRole!.id;

        // If user has 'User' role but we select 'Admin' -> Grant 'Admin' role
        if (userIsUser && value === adminRole!.id && !this.rolesToGrant.some((r) => r.id === adminRole!.id)) {
            this.rolesToGrant.push({ id: adminRole!.id, name: adminRole!.name });
        }
        // If user has 'Admin' role but we select 'User' -> Revoke 'Admin' role
        if (userIsAdmin && value === userRole!.id && !this.rolesToRevoke.some((r) => r.id === adminRole!.id)) {
            this.rolesToRevoke.push({ id: adminRole!.id, name: adminRole!.name });
        }
    }

    public allRoles(): Array<{ id: string, name: string, displayName: string }> {
        const all = new Array<{ id: string, name: string, displayName: string }>(...[
            { id: '92ac7cb6-d61a-4fa7-ae27-31178d31b8eb', name: 'role:admin', displayName: 'Administrator' },
            { id: 'f21e885c-9e93-440a-b701-f14043ca06f9', name: 'role:user', displayName: 'User' }
        ]);

        return all;
    }
    public priorityRoleId(): string {
        const adminRole = this.user.roles.find((r) => r.roleId === '92ac7cb6-d61a-4fa7-ae27-31178d31b8eb') || null;
        if (adminRole !== null) {
            return adminRole.roleId;
        }

        return 'f21e885c-9e93-440a-b701-f14043ca06f9';
    }
    public save(): void {
        this.$emit('user-roles-saved', this.rolesToGrant, this.rolesToRevoke);
    }
    public toggleShow(): void {
        if (this.showing) {
            this.$emit('user-roles-show');
        } else {
            this.$emit('user-roles-hide');
        }
    }
    @Watch('show')
    public toggle(value: boolean): void {
        this.showing = value;
    }
    public async mounted(): Promise<void> {
        this.selectedRoleId = this.priorityRoleId();
    }
}
